import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * Metadata Definitions API service
 */
export const MetadataDefinitionApi = {
  /**
   * Get document metadata definitions
   * @returns {Promise<Response>} Document metadata definitions response
   */
  getDocumentMetadataDefinitions: async () => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/metadata-definitions/document`, {
      method: 'GET',
    });
  },

  /**
   * Get document metadata definition by ID
   * @param {string|number} id - Metadata definition ID
   * @returns {Promise<Response>} Document metadata definition response
   */
  getDocumentMetadataDefinition: async (id) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/metadata-definitions/document/${id}`, {
      method: 'GET',
    });
  },

  /**
   * Create document metadata definition
   * @param {Object} data - Metadata definition data
   * @returns {Promise<Response>} Create response
   */
  createDocumentMetadataDefinition: async (data) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/metadata-definitions/document`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  },

  /**
   * Update document metadata definition
   * @param {string|number} id - Metadata definition ID
   * @param {Object} data - Updated metadata definition data
   * @returns {Promise<Response>} Update response
   */
  updateDocumentMetadataDefinition: async (id, data) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/metadata-definitions/document/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  },

  /**
   * Delete document metadata definition
   * @param {string|number} id - Metadata definition ID
   * @returns {Promise<Response>} Delete response
   */
  deleteDocumentMetadataDefinition: async (id) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/metadata-definitions/document/${id}`, {
      method: 'DELETE',
    });
  },
};